import axios from "axios";

export class EnumProvider {
  public async getDataSource(enumType: string) {
    const { data } = await axios(`/${enumType}/get`);
    return data;
  }
}
